import { createLabeledMessages } from '../../../messageUtils';
const person = {
    firstName: 'first name',
    surname: 'surname',
    birthNumber: 'birth number',
    birthNumber_short: 'RČ',
    birthDate: 'birth date',
    ico: 'IČO',
    type: 'person type',
    degreeBefore: 'degree before',
    degreeAfter: 'degree after',
    phone: 'phone',
    mobile: 'mobile phone',
    email: 'e-mail',
    logon: 'username',
    foreigner: 'foreigner',
    nationality: 'nationality',
    count: 'person count'
};
export default Object.assign({}, person, createLabeledMessages(person));
